import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function PricingCTA() {
  return <section id="unete" className="py-12 lg:py-16 bg-white" data-id="element-188">
      <div className="container mx-auto px-4 md:px-6" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto bg-link-light/30 rounded-[3rem] p-8 md:p-12 lg:p-16 border border-blue-100 text-center relative overflow-hidden" data-id="element-190">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-191">
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-link-blue/10 rounded-full blur-3xl" data-id="element-192" />
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl" data-id="element-193" />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-link-dark mb-6" data-id="element-194">
            Empieza hoy tu transformación digital
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-195">
            Únete a Skool y accede a cursos, comunidad, herramientas de IA y una
            ruta clara para avanzar.
          </p>

          <div className="mb-10" data-id="element-196">
            <span className="inline-block bg-white px-6 py-2 rounded-full text-link-navy font-bold text-xl shadow-sm border border-gray-100" data-id="element-197">
              Desde $5/mes
            </span>
          </div>

          <a href="https://www.skool.com/link-academy-1317" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center bg-link-blue hover:bg-blue-700 text-white px-10 py-5 rounded-full font-bold text-xl transition-all shadow-xl shadow-link-blue/30 hover:shadow-link-blue/50 hover:-translate-y-1 mb-8 w-full sm:w-auto" data-id="element-198">
            Únete a Skool ahora
          </a>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-medium text-gray-500" data-id="element-199">
            <div className="flex items-center gap-2" data-id="element-200">
              <CheckCircle2 className="text-link-blue" size={16} data-id="element-201" />
              <span data-id="element-202">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-203">
              <CheckCircle2 className="text-link-blue" size={16} data-id="element-204" />
              <span data-id="element-205">Cancela cuando quieras</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-206">
              <CheckCircle2 className="text-link-blue" size={16} data-id="element-207" />
              <span data-id="element-208">Comunidad en español</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}